if (!window.Eurus.loadedScript.has('preview-color-swatches.js')) {
  window.Eurus.loadedScript.add('preview-color-swatches.js');

  const initPreviewColorSwatches = () => {
    if (!window.Alpine || window.Eurus.previewColorSwatchInitialized) return;
    window.Eurus.previewColorSwatchInitialized = true;

      Alpine.data('xProductCard', (
        sectionId,
        productUrl,
        productId,
      ) => ({
        currentVariantCard: '',
        options: [],
        isSelect: false,
        productId: productId,
        showOptions: false,
        init() {          
          document.addEventListener(`eurus:product-card-variant-select:updated:${sectionId}`, (e) => {
            this.checkVariantSelected();
            this.currentVariantCard = e.detail.currentVariant;
            this.options = e.detail.options;
          });
        },
        checkVariantSelected() {
          const fieldset = [...document.querySelectorAll(`#variant-update-${sectionId} fieldset`)];
          if(fieldset.findIndex(item => !item.querySelector("input:checked")) == "-1") {
            this.isSelect = true;
          }
        }
      }));

      Alpine.data('xDoubleTouch', (productUrl, minimumTouchDuration = 0) => ({
        lastTapTime: 0,
        DOUBLE_TAP_DELAY: 300,
        singleTapTimeout: null,
        touchStartX: 0,
        touchStartY: 0,
        touchMoved: false,
        MAX_MOVE_THRESHOLD: 10,
        MIN_TOUCH_DURATION: minimumTouchDuration,
        touchStartedAt: 0,
        touchStartScrollY: 0,
        showSecond: false,

        get requiresDeliberateTouch() {
          return this.MIN_TOUCH_DURATION > 0 && window.matchMedia('(max-width: 767px)').matches;
        },

        onTouchStart(event) {
          if (this.requiresDeliberateTouch) clearTimeout(this.singleTapTimeout);
          const touch = event.touches[0];
          this.touchStartedAt = Date.now();
          this.touchStartScrollY = window.scrollY;
          this.touchStartX = touch.clientX;
          this.touchStartY = touch.clientY;
          this.touchMoved = false;
        },
  
        onTouchMove(event) {
          const touch = event.touches[0];
          const deltaX = Math.abs(touch.clientX - this.touchStartX);
          const deltaY = Math.abs(touch.clientY - this.touchStartY);
          const threshold = this.requiresDeliberateTouch ? 8 : this.MAX_MOVE_THRESHOLD;
          if (deltaX > threshold || deltaY > threshold) {
            this.touchMoved = true;
          }
        },
  
        onTouchEnd(splide, carousel, event) {
          const touch = event?.changedTouches[0];
          if (this.requiresDeliberateTouch && touch && (
            Math.abs(touch.clientX - this.touchStartX) > 8 ||
            Math.abs(touch.clientY - this.touchStartY) > 8
          )) this.touchMoved = true;
          if (this.requiresDeliberateTouch && (
            event?.mobileCardTouchAllowed === false ||
            Date.now() - this.touchStartedAt < this.MIN_TOUCH_DURATION ||
            Math.abs(window.scrollY - this.touchStartScrollY) > 8 ||
            this.touchMoved
          )) {
            this.onTouchCancel();
            return;
          }
          if (this.touchMoved) {
            return;
          }
  
          const currentTime = new Date().getTime();
          const tapLength = currentTime - this.lastTapTime;
  
          if (tapLength < this.DOUBLE_TAP_DELAY && tapLength > 0) {
            clearTimeout(this.singleTapTimeout);
            this.lastTapTime = 0;
            this.onDoubleTap(splide, carousel);
          } else {
            this.lastTapTime = currentTime;
            this.singleTapTimeout = setTimeout(() => {
              if (this.requiresDeliberateTouch && (
                this.touchMoved || Math.abs(window.scrollY - this.touchStartScrollY) > 8
              )) {
                this.onTouchCancel();
                return;
              }
              this.onSingleTap();
            }, this.DOUBLE_TAP_DELAY);
          }
        },

        onTouchCancel() {
          clearTimeout(this.singleTapTimeout);
          this.singleTapTimeout = null;
          this.lastTapTime = 0;
          this.touchMoved = true;
        },
  
        onSingleTap() {
          window.location.href= productUrl
        },
  
        onDoubleTap(splide, carousel) {
          if (carousel) {
            Alpine.store('xSplide').togglePlayPause(splide)
          } else {
            this.showSecond = !this.showSecond;
          }
        }
      }));

      Alpine.store('xPreviewColorSwatch', {
        onChangeVariant(el, productUrl, src, variantId, sectionId, isColor = false) {
          setTimeout(() => {
            document.addEventListener(`eurus:product-card-variant-select:updated:${sectionId}`, (e) => {
              if (e.detail.currentVariant == null) {
                this.updateImage(el, productUrl, src, variantId, sectionId);
              }
            }, { once: true });

            if (!isColor) {
              let productVariants = ''

              document.dispatchEvent(new CustomEvent(`eurus:product-variant-get:${sectionId}`, {
                detail: {
                  callback: (variants) => {
                    productVariants = variants;
                  }
                }
              }));

              if (productVariants) {
                let variantSrc = productVariants.reduce((acc, variant) => {
                  if (variant.featured_image) {
                    acc[variant.id] = variant.featured_image.src;
                  }
                  return acc;
                }, {});
        
                const swatchesContainer = el.closest('.options-container');
                if (swatchesContainer) {
                  const swatches = swatchesContainer.querySelectorAll('label.color-watches');
                  const inputs = swatchesContainer.querySelectorAll('input:checked');
      
                  let selectedOption = [];
      
                  inputs.forEach(input => { 
                    if (![...swatches].some(swatch => swatch.dataset.optionvalue === input.value)) {
                      selectedOption.push(input.value.replace(/\\u003c/g, '<').replace(/\\u003e/g, '>'));
                    }
                  });
      
                  let imageSrc = productVariants
                    .filter(variant => selectedOption.every(option => variant.options.includes(option)))
                    .reduce((acc, variant) => {
                      swatches.forEach((swatch) => {
                        if (variant.options.includes(swatch.getAttribute('data-optionvalue'))) {
                          acc[swatch.getAttribute('data-optionvalue')] =  `url(${variantSrc[variant.id] ? variantSrc[variant.id] : src})`
                        }
                      });
                      return acc;
                    }, {});
                  swatches.forEach((swatch) => {
                    swatch.style.setProperty('--bg-image',  imageSrc[swatch.getAttribute('data-optionvalue')]);
                  });
                }
              }
            } 
          }, 0) // INP
        },

        updateImage(el, productUrl, src, variantId, sectionId, hasVariant) {
          const cardProduct = el.closest('.card-product');
          let getLink =  productUrl + `?variant=${variantId}`;
          if (!cardProduct) return;
          const linkVariant = cardProduct.getElementsByClassName("link-product-variant");
          for (var i = 0; i < linkVariant.length; i ++) {
            linkVariant[i].setAttribute("href", getLink);
          }
          const currentVariant = cardProduct.querySelector(".current-variant");
          if (currentVariant && !hasVariant) {
            currentVariant.innerText = variantId;
          }

          if (src != '') {
            let media = cardProduct.querySelector(`[media="${src}"]`);
            if (media) {
              let index = media.getAttribute('index');
              let slide = cardProduct.querySelector('.x-splide');
              if (slide) {
                if (slide.splide) {
                  slide.splide.go(Number(index));
                } else {
                  document.addEventListener(`eurus:${sectionId}:splide-ready`, () => {
                    slide.splide.go(Number(index));
                  });
                }
                return;
              } 
            }
            const previewImg = cardProduct.getElementsByClassName("preview-img")[0];
            if (!previewImg) return;
            previewImg.removeAttribute("srcset");
            previewImg.setAttribute("src", src);
            let slide = cardProduct.querySelector('.x-splide');
            if (slide && slide.splide) {
              slide.splide.go(0);
            }
          } else {
            let slide = cardProduct.querySelector('.x-splide');
            if (slide && slide.splide) {
              slide.splide.go(0);
            }
          }
        },
        updateQuickAdd(productUrl, variantId, quickAddPageParam, productId, el){
          const cardProduct = el?.closest('.card-product');
          let resolvedVariantId = variantId;
          const currentVariantElement = cardProduct?.querySelector('.current-variant');
          if (currentVariantElement) {
            const rawCurrentVariant = currentVariantElement.textContent?.trim();
            if (rawCurrentVariant) {
              try {
                const parsedVariant = JSON.parse(rawCurrentVariant);
                if (parsedVariant && typeof parsedVariant === 'object' && parsedVariant.id) {
                  resolvedVariantId = parsedVariant.id;
                } else if (parsedVariant) {
                  resolvedVariantId = parsedVariant;
                }
              } catch (_) {
                resolvedVariantId = rawCurrentVariant;
              }
            }
          }

          if (!resolvedVariantId) return;

          let url = `${productUrl}?variant=${resolvedVariantId}&section_id=choose-option&page=${quickAddPageParam}`
          fetch(url)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const listCurrent = document.querySelectorAll(`#product-form-choose-option${productId}${quickAddPageParam ?? ''}`);
            const destination = html.querySelector(`#product-form-choose-option${productId}${quickAddPageParam ?? ''}`);
            const fallbackForm = html.querySelector('.form');

            if (listCurrent.length > 0) {
              listCurrent.forEach((item) => {
                if (destination) {
                  item.innerHTML = destination.innerHTML;
                } else if (fallbackForm) {
                  item.innerHTML = fallbackForm.innerHTML;
                }
              })
            }

            const currentPrice = cardProduct?.querySelector(".main-product-price");
            const updatePrice = html.querySelector(".main-product-price");
            if(currentPrice && updatePrice){
              currentPrice.innerHTML = updatePrice.innerHTML
            }
          })
        }
      });
  };

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', initPreviewColorSwatches, { once: true });
    initPreviewColorSwatches();
  });
}    
